import { jsx } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { token } from "./token.js";
import { Spinner } from "./Spinner.js";
import { makeInternalTokens } from "./makeInternalTokens.js";
const pointerEventsClassname = "ds-thumbnail__pointer-events-wrapper";
function Overlay({
  children,
  isConcealed = false,
  isLoading = false,
  ...props
}) {
  return /* @__PURE__ */ jsx(OverlayStyled, {
    $isConcealed: isConcealed,
    ...props,
    children: isLoading ? /* @__PURE__ */ jsx(Spinner, {
      "data-testid": "ds-thumbnail-overlay-spinner"
    }) : children
  });
}
const {
  internalTokens,
  declareTokens
} = makeInternalTokens({
  lightTheme: {
    "thumbnail-overlay-fill": token.gray200a,
    "thumbnail-overlay-color": token.gray10
  },
  darkTheme: {
    "thumbnail-overlay-fill": "rgb(3 16 38 / 20%)",
    // same value as gray200a for light theme
    "thumbnail-overlay-color": token.gray1000
  }
});
const OverlayStyled = styled.div.withConfig({
  displayName: "OverlayStyled",
  componentId: "sc-7kyl1s-0"
})(["", " position:absolute;top:0;left:0;display:grid;place-items:center;width:100%;height:100%;border-radius:var(--ds-thumbnail-border-radius);background:", ";color:", ";-webkit-mask-image:var(--ds-thumbnail-overlay-indicator-cutout);mask-image:var(--ds-thumbnail-overlay-indicator-cutout);", ""], declareTokens, internalTokens["thumbnail-overlay-fill"], internalTokens["thumbnail-overlay-color"], (props) => props.$isConcealed && css(["opacity:0;", ":hover &,", ":focus-visible &{opacity:1;}"], "." + pointerEventsClassname, "." + pointerEventsClassname));
export {
  Overlay,
  pointerEventsClassname
};
//# sourceMappingURL=Overlay.js.map
